import axios from '../utils/axios';

export default function getFreeListingFilesList(adminId) {
    return axios.get(`/admin/${adminId}/get-free-listing-files`);
}